import { FocusZone } from './elements/FocusZone/FocusZone.js';
import { ToggleButton } from './elements/ToggleButton/ToggleButton.js';

function loadPolyfills() {
  const polyfills = [];

  if (! ('popover' in HTMLElement.prototype)) {
    polyfills.push(import('@oddbird/popover-polyfill'));
  }

  if (! ('command' in HTMLButtonElement.prototype)) {
    polyfills.push(import('invokers-polyfill'));
  }

  return Promise.all(polyfills);
}

function defineCustomElements() {
  customElements.define('focus-zone', FocusZone);
  customElements.define('toggle-button', ToggleButton);
}

function bootApplication() {
  loadPolyfills();
  defineCustomElements();
}

bootApplication();